export default "__VITE_ASSET__Z_xpH2jM__"